import getLanguageFromStorage from 'syf-js-utilities/helpers/getLanguageFromStorage';
import config from '../const/config';
import getSelectedEnv from './get-selected-env';
const { NODE_ENV } = process.env;
const selectedEnv = getSelectedEnv();
const isProduction = NODE_ENV === 'production';
export const mockBaseURL = 'https://a2e502b0-453c-41d9-a839-eea61e73a6e7.mock.pstmn.io';
export const apigeeURL = !isProduction
    ? `https://api-${selectedEnv}.syf.com`
    : config.API_HOST;
const serviceFileConfigPath = {
    nonprod: `serviceFiles/json/${selectedEnv}/vista-config.json`,
    prod: 'https://images.synchronycredit.com/serviceFiles/json/vista-config.json'
};
export const assetsURL = !isProduction
    ? `https://${selectedEnv}.synchronycredit.com`
    : config.ASSETS_HOST;
export const serviceFilesURL = !isProduction
    ? `${assetsURL}/${serviceFileConfigPath.nonprod}`
    : serviceFileConfigPath.prod;
export const APP_ENV = !isProduction ? 'development' : config.APP_ENV;
// Default fallback config if not provided by channel app
const accountActionsConfig = {
    hosts: {
        apigee: new URL(apigeeURL),
        assets: new URL(assetsURL),
        serviceFile: new URL(serviceFilesURL)
    },
    apiErrorCallback: () => undefined,
    lang: getLanguageFromStorage()
};
/*
 * Use getSandboxConfig to avoid getting an outdated
 * sandboxConfig when a component is rendered
 */
export const getSandboxConfig = () => {
    const isMockData = Boolean(sessionStorage.getItem('mockData'));
    const apiHost = !isMockData ? apigeeURL : mockBaseURL;
    const currentServiceFileURL = `${!isMockData ? assetsURL : mockBaseURL}/${serviceFileConfigPath.nonprod}`;
    return {
        hosts: {
            apigee: new URL(apiHost),
            assets: new URL(assetsURL),
            serviceFile: new URL(currentServiceFileURL)
        },
        lang: getLanguageFromStorage(),
        apiErrorCallback: () => undefined
    };
};
// This sandboxConfig is used only by test cases
export const sandboxConfig = getSandboxConfig();
export default accountActionsConfig;
